import { Injectable, inject } from "@angular/core";
import type { TeamDTO } from "@magpie/types";
import { TrpcService } from "./trpc.service";

@Injectable({ providedIn: "root" })
export class AdminTeamService {
	private readonly trpc = inject(TrpcService);

	list() {
		return this.trpc.client.adminTeam.list.query();
	}

	get(teamId: string): Promise<TeamDTO> {
		return this.trpc.client.adminTeam.get.query({ teamId });
	}

	rename(teamId: string, name: string): Promise<TeamDTO> {
		return this.trpc.client.adminTeam.rename.mutate({ teamId, name });
	}

	regenerateCode(teamId: string): Promise<TeamDTO> {
		return this.trpc.client.adminTeam.regenerateCode.mutate({ teamId });
	}

	addGhost(teamId: string, nickname: string): Promise<TeamDTO> {
		return this.trpc.client.adminTeam.addGhost.mutate({ teamId, nickname });
	}

	removeMember(teamId: string, memberId: string): Promise<TeamDTO> {
		return this.trpc.client.adminTeam.removeMember.mutate({ teamId, memberId });
	}

	setMemberActive(
		teamId: string,
		memberId: string,
		isActive: boolean,
	): Promise<TeamDTO> {
		return this.trpc.client.adminTeam.setMemberActive.mutate({
			teamId,
			memberId,
			isActive,
		});
	}

	teamsForDash(dashId: string) {
		return this.trpc.client.adminDash.teamsForDash.query({ dashId });
	}

	dashesForTeam(teamId: string) {
		return this.trpc.client.adminDash.dashesForTeam.query({ teamId });
	}
}
